export const SURFACE_NAMES = [
  "claude",
  "cursor",
  "codex",
  "deepseek",
  "openclaw",
  "vscode",
  "windsurf",
  "zed",
  "chatgpt",
] as const;

export type SurfaceName = (typeof SURFACE_NAMES)[number];
export type SurfaceMode = "automated" | "manual";

export const AUTOMATED_SURFACE_NAMES = [
  "claude",
  "cursor",
  "codex",
  "deepseek",
  "openclaw",
  "vscode",
  "windsurf",
  "zed",
] as const satisfies readonly SurfaceName[];

export const MCP_SURFACE_NAMES = [
  "claude",
  "cursor",
  "codex",
  "vscode",
  "windsurf",
  "zed",
] as const;
